import React, { Component } from "react";
import ReactPaginate from "react-paginate";

class Pagination extends Component {
    handlePageClick = page => {
        this.props.updatePaginate(page.selected + 1);
    };

    render() {
        return (
            <div className="padding_bottom text-center">
                <ReactPaginate
                    previousLabel={"قبلی"}
                    nextLabel={"بعدی"}
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    initialPage={this.props.paginate.currentPage - 1}
                    pageCount={this.props.paginate.pageCount}
                    marginPagesDisplayed={1}
                    pageRangeDisplayed={1}
                    onPageChange={this.handlePageClick}
                    containerClassName={"pagination"}
                    subContainerClassName={"pages pagination"}
                    activeClassName={"active"}
                />
            </div>
        );
    }
}
export default Pagination;
